function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#B7C1D5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "M9.58 2.73a6.77 6.77 0 100 13.54 6.77 6.77 0 000-13.54zm-8 6.77a8 8 0 1116 0 8 8 0 01-16 0z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.58 14.42a.92.92 0 100-1.84.92.92 0 000 1.84z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.52 5.4a2.77 2.77 0 111.68 5.26v.07a.62.62 0 01-1.23 0v-.62a.62.62 0 01.61-.61 1.54 1.54 0 10-1.54-1.54.62.62 0 01-1.23 0A2.77 2.77 0 018.52 5.4z",
  clipRule: "evenodd"
});

function SvgQuestionOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#B7C1D5",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOutlined);
export default __webpack_public_path__ + "static/media/question-outlined.fb3e785b.svg";
export { ForwardRef as ReactComponent };